module.exports = __webpack_public_path__ + "img/health-report.a0d073d5.svg";